import { useLocation } from 'react-router-dom';

import { SM_MIN } from '@rover/kibble/styles/MediaQuery';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';

import { SEARCH_BY_NAME_OPEN_PARAM } from '../constants';

import { useSearchByNameExperiment } from './useSearchByNameExperiment';

export const useSearchByNameRedirect = (): boolean => {
  const { search } = useLocation();
  const { isEnabled } = useSearchByNameExperiment();
  const isMobile = !useMatchMedia(`(min-width:${SM_MIN}px)`);
  const hasOpenParam = new URLSearchParams(search).get(SEARCH_BY_NAME_OPEN_PARAM) === 'true';
  return hasOpenParam && isEnabled && !isMobile;
};
